<template>
  <div>
    <b-modal
      id="modal-change-debtors"
      ref="modal-change-debtors"
      centered
      :title="$t('DEBTIA_CHANGE_CASE_DEBTORS')"
      :ok-title="$t('DEBTIA_UPDATE')"
      :no-close-on-backdrop="true"
      cancel-variant="outline-secondary"
      size="lg"
      @show="resetModal"
      @hidden="resetModal"
      @ok="confirmation"
    >
      <b-overlay
        id="overlay-background"
        :show="loader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="md"
        spinner-variant="primary"
        spinner-medium
      >
        <b-alert
          v-if="errorMsg"
          variant="warning"
          show
        >
          <div class="alert-body">
            <span>{{ errorMsg }}</span>
          </div>
        </b-alert>
        <b-form
          ref="form"
          class="repeater-form"
          @submit.prevent="repeatAgain"
        >
          <!-- Row Loop -->
          <b-row
            v-for="(item, index) in caseDebtors"
            :id="index"
            :key="index"
            ref="row"
          >
            <!-- Remove Button -->
            <b-col
              v-if="item.is_main_debtor === false"
              md="1"
            >
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2"
                @click="removeItem($event, index, item.old_debtor_id)"
              >
                <feather-icon
                  icon="XIcon"
                  class="mr-25"
                />
              </b-button>
            </b-col>
            <!-- Old Debtor -->
            <b-col
              md="4"
            >
              <b-form-group
                :label="$t('DEBTIA_OLD_DEBTOR')"
                label-for="category"
              >
                <v-select
                  v-model="item.old_debtor_id"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  class="old_debtor_id"
                  :options="clientDebtorsOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="old_debtor_id"
                  :disabled="true"
                  :aria-selected="true"
                />
              </b-form-group>
            </b-col>

            <!-- New Debtor -->
            <b-col
              md="4"
            >
              <b-form-group
                :label="$t('DEBTIA_NEW_DEBTOR')"
                label-for="category"
              >
                <v-select
                  v-model="item.new_debtor_id"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  class="new_debtor_id"
                  :options="clientDebtorsOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="new_debtor_id"
                  @input="changeNewDebtor($event, index, item.new_debtor_id)"
                />
              </b-form-group>
            </b-col>
            <!-- Mian Debtor -->
            <b-col
              md="2"
            >
              <b-form-group
                :label="$t('DEBTIA_MAIN_DEBTOR')"
                label-for="category"
                style="white-space: nowrap"
              >
                <b-form-checkbox
                  v-model="item.is_main_debtor"
                  plain
                  class="custom-control-primary"
                  style="white-space: nowrap"
                  @change="validateMainDebtorItems(caseDebtors, item)"
                >
                  {{ $t('DEBTIA_IS_MAIN_DEBTOR') }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <hr>
            </b-col>
          </b-row>
          <b-button
            v-if="caseDebtors.length < clientDebtorsOptions.length"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            @click="repeatAgain"
          >
            <feather-icon
              icon="PlusIcon"
              class="mr-25"
            />
            <span>Add New</span>
          </b-button>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BButton,
  // BFormInvalidFeedback,
  BForm,
  // BFormDatepicker,
  BAlert, BOverlay,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import axios from '@axios'
import vSelect from 'vue-select'
import i18n from '@/libs/i18n'

export default {
  components: {
    vSelect,
    BOverlay,
    BAlert,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    caseId: {
      type: [Number, String],
      required: true,
    },
    creditorId: {
      type: Number,
      required: true,
    },
    getDetails: {
      type: Function,
      required: true,
    },
    getDebtCaseDebtors: {
      type: Array,
      required: true,
    },
    clientDebtorsOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      debtorsBelongToCompany: localStorage.getItem('debtorsBelongTo') === 'company',
      loader: false,
      required,
      errorMsg: '',
      caseDebtors: [],
      debtorIndex: 1,
      items: [
        {
          recordIndex: 1,
          old_debtor_id: 0,
          new_debtor_id: 0,
          is_main_debtor: false,
        },
      ],
    }
  },
  watch: {
    // new_debtor_id: {
    //   handler() {
    //     this.getDetails()
    //   },
    // },
    getDebtCaseDebtors: {
      handler() {
        this.oldDebtCaseDebtor()
      },
    },
  },
  methods: {
    changeNewDebtor(event, index, newDebtorId) {
      let exists = false
      const existingNewDebtors = []
      let debtorExist = false
      this.caseDebtors.forEach(element => {
        if (element.old_debtor_id === newDebtorId) {
          exists = true
        }
        if (!existingNewDebtors.includes(element.new_debtor_id)) {
          if (element.new_debtor_id > 0) {
            existingNewDebtors.push(element.new_debtor_id)
          }
          debtorExist = false
        } else {
          debtorExist = true
        }
      })
      if (exists === true) {
        this.caseDebtors[index].new_debtor_id = 0
      }
      if (debtorExist === true) {
        this.caseDebtors[index].new_debtor_id = 0
      }
    },
    oldDebtCaseDebtor() {
      const debtors = []
      this.getDebtCaseDebtors.forEach((element, index) => {
        let isMainDebtor = false
        if (element.is_main_debtor === 1) {
          isMainDebtor = true
        }
        const obj = {
          recordIndex: index + 1,
          old_debtor_id: element.debtor_id,
          new_debtor_id: 0,
          is_main_debtor: isMainDebtor,
        }
        debtors.push(obj)
      })
      this.caseDebtors = [...debtors]
    },
    repeatAgain() {
      this.debtorIndex += 1
      const obj = {
        recordIndex: this.debtorIndex,
        old_debtor_id: 0,
        new_debtor_id: 0,
        is_main_debtor: false,
      }
      this.caseDebtors.push(obj)
    },
    resetModal() {
      this.errorMsg = ''
      this.items = [
        {
          recordIndex: 1,
          old_debtor_id: 0,
          new_debtor_id: 0,
          is_main_debtor: false,
        },
      ]
    },
    removeItem(event, index, oldDebtorId) {
      this.errorMsg = ''
      this.validateDebtorsItems(this.caseDebtors)
      let countOldDebtors = 0
      for (const item of this.getDebtCaseDebtors) {
        if (item.debtor_id > 0) {
          countOldDebtors += 1
        }
      }
      this.errorMsg = ''
      if (countOldDebtors === 1 && oldDebtorId > 0) {
        this.errorMsg = 'Debtor cannot be deleted!'
        return false
      }
      const msg = 'DEBTIA_DELETE_CASE_DEBTOR_MSG'
      if (this.selectedClient === 0) {
        this.errorMsg = 'Fill the highlighted fields'
      }
      this.$swal({
        title: i18n.t('DEBTIA_CAUTION'),
        text: i18n.t(msg),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          if (oldDebtorId === 0) {
            this.caseDebtors.splice(index, 1)
          } else {
            this.loader = true
            const url = '/delete-debt-case-debtor'
            const obj = {
              debt_case_id: this.caseId,
              debtor_id: oldDebtorId,
            }
            axios.post(url, obj).then(response => {
              if (response.status === 200) {
                this.loader = false
                this.$refs['modal-change-debtors'].hide()
                this.getDetails()
              }
            }).catch(error => {
              this.loader = false
              this.errorMsg = error.response.data.message ? error.response.data.message : error.message
            })
          }
        }
      })
      return true
    },
    isNotEmptyArray(variable) {
      if (Array.isArray(variable) && variable.length > 0) {
        return !variable.some(item => Array.isArray(item) && item.length === 0)
      }
      return false
    },
    confirmation(evt) {
      evt.preventDefault()
      this.errorMsg = ''
      if (!this.debtorsBelongToCompany) {
        this.validateDebtorsItems(this.caseDebtors)
        const isValid = this.validateMainDebtorItems(this.caseDebtors)
        if (!isValid) {
          this.errorMsg = 'Only one debtor can be marked as main!'
        }
      }
      if (!this.debtorsBelongToCompany && this.isNotEmptyArray(this.caseDebtors) === false) {
        this.errorMsg = 'Add at least one debtor!'
      }
      const msg = 'DEBTIA_CHANGE_CASE_DEBTOR_MSG'
      if (!this.errorMsg) {
        this.$swal({
          title: i18n.t('DEBTIA_CAUTION'),
          text: i18n.t(msg),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: i18n.t('DEBTIA_YES'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            this.changeCaseDebtor()
          }
        })
      }
      return true
    },
    validateDebtorsItems(debtorItems) {
      for (const item of debtorItems) {
        if (item.old_debtor_id === 0 && item.new_debtor_id === 0) {
          this.errorMsg = 'Debtor should be selected!'
          return false
        }
      }
      return true // Validation passes if there is at most one item with is_main_debtor set to true
    },
    validateMainDebtorItems(debtorItems, item = []) {
      this.errorMsg = ''
      if (item.old_debtor_id === 0 && item.new_debtor_id === 0 && item.is_main_debtor === true) {
        this.errorMsg = 'Debtor cannot be marked as main!'
        return false // Validation fails if more than one item has is_main_debtor set to true
      }
      let countMainDebtors = 0
      for (const debtorItem of debtorItems) {
        if (debtorItem.old_debtor_id === 0 && debtorItem.new_debtor_id === 0 && debtorItem.is_main_debtor === true) {
          this.errorMsg = 'Debtor cannot be marked as main!'
          return false // Validation fails if more than one item has is_main_debtor set to true
        }
        if (debtorItem.is_main_debtor) {
          countMainDebtors += 1
          if (countMainDebtors > 1) {
            this.errorMsg = 'Only one debtor can be marked as main!'
            return false // Validation fails if more than one item has is_main_debtor set to true
          }
        }
      }
      if (countMainDebtors === 0) {
        this.errorMsg = 'One main debtor should be selected!'
        return false // Validation fails if more than one item has is_main_debtor set to true
      }
      return true // Validation passes if there is at most one item with is_main_debtor set to true
    },
    changeCaseDebtor() {
      this.errorMsg = ''
      this.loader = true
      const url = '/change-debt-case-debtor'
      const debtors = []
      this.caseDebtors.forEach(element => {
        if (element.old_debtor_id > 0 || element.new_debtor_id > 0) {
          const obj = {
            old_debtor_id: element.old_debtor_id,
            new_debtor_id: element.new_debtor_id,
            is_main_debtor: element.is_main_debtor,
          }
          debtors.push(obj)
        }
      })
      const data = []
      data.debtors = debtors
      data.debt_case_id = this.caseId
      const debtorsData = { ...data }
      axios.post(url, debtorsData).then(response => {
        this.loader = false
        if (response.status === 200) {
          this.$refs['modal-change-debtors'].hide()
          this.getDetails()
        }
      }).catch(error => {
        this.loader = false
        this.errorMsg = error.response.data.message ? error.response.data.message : error.message
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss">
.modal-lg {
  max-width: 1000px;
}
</style>
